import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d2f2a84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sticker-wrapper"
}
const _hoisted_2 = { class: "sticker-container" }
const _hoisted_3 = { class: "sticker-view" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "sticker-view__box-group" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = ["src"]

import { ref, onMounted, computed, nextTick, onBeforeUnmount } from 'vue';
import { storeToRefs } from 'pinia';
import { game } from '@/utils/game';
import { useInfo, useWorkshop } from '@/store';
import {
  useBackgroundUrl,
  useImgSrc,
} from '@/components/workshop/useWorkshopImg';
import utils from '@/utils';
import useScrollbar from '@/hooks/useScrollbar';

// components
import Button from '@/components/workshop/Button';
import ImageBox, {
  ImageBoxType,
} from '@/components/workshop/Playground/ImageBox';
import BaseMap from '@/components/workshop/Playground/Basemap';
import Sticker from '@/components/workshop/Playground/Sticker';


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

_useCssVars(_ctx => ({
  "1b7b520d": (_unref(mainBg).mobile),
  "26a7ffd1": (_unref(mainBg).tablet),
  "0a083cde": (_unref(mainBg).pc),
  "32420aa3": (_unref(playgroundFrame).mobile),
  "3d6eb867": (_unref(playgroundFrame).tablet),
  "476afefd": (_unref(stickerbox).mobile),
  "5297acc1": (_unref(stickerbox).tablet),
  "a1983c64": (_unref(stickerbox).pc),
  "473bca6c": (_unref(stickerboxEffect).mobile),
  "52687830": (_unref(stickerboxEffect).tablet)
}))

const { checkIsInGame, runScreenShot } = game;
const { mainBg, playgroundFrame, stickerbox, stickerboxEffect } =
  useBackgroundUrl();
const { scrollArrow } = useImgSrc();
const {
  changeBasemap,
  updateSelectedSticker,
  updateScreenshotMode,
  eventSticker,
  updateWaitScreenshot,
} = useWorkshop();
const { translations } = storeToRefs(useInfo());
const { currentBasemap, currentStickerList, currentPlaygroundStickers, waitScreenshot } =
  storeToRefs(useWorkshop());
const pxToRem = 0.01;
// For scroll area DOM
const stickerGroup = ref<HTMLDivElement | null>(null);
const initImageBoxState = {
  imageBoxId: null,
  stickerId: null,
  stickerImg: null,
  stickerListIndex: null,
};
const imageBoxState = ref<{
  imageBoxId: null | number;
  stickerId: null | number;
  stickerImg: null | string;
  stickerListIndex: null | number;
}>({ ...initImageBoxState });

const currentPlaygroundStickerItem = computed(() => {
  if (imageBoxState.value.stickerListIndex !== null)
    return currentPlaygroundStickers.value[imageBoxState.value.stickerListIndex]
      .selectedSticker;
  return { id: null, img: null };
});

const { scrollData, onScroll } = useScrollbar();
const isScrollArrowShow = computed(() => {
  if (
    window.matchMedia('min-width: 750px').matches ||
    window.matchMedia('(orientation:landscape)').matches
  ) {
    return currentStickerList.value.length > 9 && !scrollData.isScrollBottom;
  }
  return currentStickerList.value.length > 12 && !scrollData.isScrollBottom;
});
function handleScroll() {
  if (
    !Array.isArray(currentStickerList.value) ||
    currentStickerList.value.length === 0
  )
    return;
  onScroll(stickerGroup);
}
function onImageBoxClick(imageBoxId: number, stickerListIndex: number) {
  if (
    imageBoxId === imageBoxState.value.imageBoxId &&
    imageBoxState.value.stickerId
  )
    return;

  imageBoxState.value = {
    imageBoxId,
    stickerListIndex,
    stickerId: currentPlaygroundStickerItem.value.id,
    stickerImg: currentPlaygroundStickerItem.value.img,
  };
}
function onErase(stickerListIndex: number) {
  imageBoxState.value = {
    ...imageBoxState.value,
    stickerId: null,
    stickerImg: null,
  };
  updateSelectedSticker(
    { selectedSticker: { id: null, img: null }, type: ImageBoxType.Create },
    stickerListIndex,
  );
}
function onStickerClick(id: number) {
  if (imageBoxState.value.imageBoxId === null) return;
  const currentSticker = currentStickerList.value.find(
    (item) => item.id === id,
  );
  imageBoxState.value = {
    ...imageBoxState.value,
    stickerId: id,
    stickerImg: currentSticker?.image || '',
  };
  if (imageBoxState.value.stickerListIndex !== null)
    updateSelectedSticker(
      {
        selectedSticker: { id, img: currentSticker?.image || null },
      },
      imageBoxState.value.stickerListIndex,
    );
}
// In-game cannot use async await
// and for some in-game browser issue
// need to use setTimeout to wrap to impliment native screenshop.
const screenshotTimer = ref<null | ReturnType<typeof setTimeout>>(null);
const screenshotReady = ref(false);
function doScreenshot() {
  if (!screenshotReady.value) return;
  if (checkIsInGame() && !waitScreenshot.value) {
    screenshotReady.value = false;
    updateScreenshotMode(true);
    updateWaitScreenshot(true);
    screenshotTimer.value = setTimeout(() => {
      runScreenShot()?.then(
        () => {
          updateWaitScreenshot(false);
          updateScreenshotMode(false);
          screenshotTimer.value && clearTimeout(screenshotTimer.value);
          screenshotReady.value = true;
        },
        (error) => {
          // screenshot failed
          updateWaitScreenshot(false);
          updateScreenshotMode(false);
          alert(error);
          screenshotTimer.value && clearTimeout(screenshotTimer.value);
          screenshotReady.value = true;
        },
      );
    }, 300);
  } else {
    updateScreenshotMode(true);
  }
}

async function onBasemapChange(index: number) {
  // reset state
  imageBoxState.value = { ...initImageBoxState };
  changeBasemap(index);
  await nextTick();
  handleScroll();
}
function getImageBoxType(
  sticker: { id: number | null; img: string | null },
  imageBoxId: number,
) {
  if (
    sticker.img &&
    sticker.id &&
    imageBoxState.value.imageBoxId !== imageBoxId
  )
    return ImageBoxType.Display;
  else if (
    imageBoxId === imageBoxState.value.imageBoxId &&
    currentPlaygroundStickerItem.value.id
  )
    return ImageBoxType.Edit;
  else return ImageBoxType.Create;
}

function resetSelectSticker() {
  imageBoxState.value = { ...initImageBoxState };
}

onMounted(async () => {
  await nextTick();
  await utils.delay(2000);
  screenshotReady.value = true;
  handleScroll();
});
onBeforeUnmount(() => {
  screenshotTimer.value && clearTimeout(screenshotTimer.value);
});

return (_ctx: any,_cache: any) => {
  return (_unref(eventSticker))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "playground",
              onClick: _withModifiers(resetSelectSticker, ["stop"]),
              style: _normalizeStyle({ backgroundImage: `url(${_unref(currentBasemap)})` })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentPlaygroundStickers), (item, index) => {
                return (_openBlock(), _createBlock(_unref(ImageBox), {
                  key: item.imageBoxId,
                  style: _normalizeStyle({
              top: `${item.y}%`,
              left: `${item.x}%`,
            }),
                  size: item.size * pxToRem,
                  type: getImageBoxType(item.selectedSticker, item.imageBoxId),
                  "is-selected": item.imageBoxId === imageBoxState.value.imageBoxId,
                  image: item.selectedSticker.img || '',
                  class: "playground__sticker",
                  onClick: _withModifiers(($event: any) => (onImageBoxClick(item.imageBoxId, index)), ["stop"]),
                  onErase: ($event: any) => (onErase(index))
                }, null, 8, ["style", "size", "type", "is-selected", "image", "onClick", "onErase"]))
              }), 128))
            ], 12, _hoisted_4),
            _createVNode(_unref(Button).Share, {
              class: "share-btn share-btn--mobile",
              onClick: doScreenshot
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass([
              'sticker-view__box',
              {
                'sticker-view__box--active': imageBoxState.value.imageBoxId !== null,
              },
            ])
              }, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(translations)?.IW_P4_STICKER), 1),
                _createElementVNode("div", {
                  ref_key: "stickerGroup",
                  ref: stickerGroup,
                  class: "sticker-group-container",
                  onScroll: handleScroll
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["sticker-group", {
                  'sticker-group--hide-scrollbar':
                    _unref(scrollData).isScrollBarVisible,
                }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentStickerList), (sticker) => {
                      return (_openBlock(), _createBlock(_unref(Sticker), {
                        key: sticker.id,
                        img: sticker.image,
                        "is-selected": sticker.id === _unref(currentPlaygroundStickerItem).id,
                        onClick: ($event: any) => (onStickerClick(sticker.id))
                      }, null, 8, ["img", "is-selected", "onClick"]))
                    }), 128))
                  ], 2)
                ], 544),
                _withDirectives(_createElementVNode("img", {
                  class: "sticker-group-scroll-icon",
                  src: _unref(scrollArrow).mobile
                }, null, 8, _hoisted_7), [
                  [_vShow, _unref(isScrollArrowShow)]
                ])
              ], 2),
              _createVNode(_unref(Button).Share, {
                class: "share-btn share-btn--landscape",
                onClick: doScreenshot
              })
            ])
          ]),
          _createVNode(_unref(BaseMap), { onSlide: onBasemapChange })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})